export default [
  'None',
  'Stench',
  'Drizzle',
  'Speed Boost',
  'Battle Armor',
  'Sturdy',
  'Damp',
  'Limber',
  'Sand Veil',
  'Static',
  'Volt Absorb',
  'Water Absorb',
  'Oblivious',
  'Cloud Nine',
  'Compound Eyes',
  'Insomnia',
  'Color Change',
  'Immunity',
  'Flash Fire',
  'Shield Dust',
  'Own Tempo',
  'Suction Cups',
  'Intimidate',
  'Shadow Tag',
  'Rough Skin',
  'Wonder Guard',
  'Levitate',
  'Effect Spore',
  'Synchronize',
  'Clear Body',
  'Natural Cure',
  'Lightning Rod',
  'Serene Grace',
  'Swift Swim',
  'Chlorophyll',
  'Illuminate',
  'Trace',
  'Huge Power',
  'Poison Point',
  'Inner Focus',
  'Magma Armor',
  'Water Veil',
  'Magnet Pull',
  'Soundproof',
  'Rain Dish',
  'Sand Stream',
  'Pressure',
  'Thick Fat',
  'Early Bird',
  'Flame Body',
  'Run Away',
  'Keen Eye',
  'Hyper Cutter',
  'Pickup',
  'Truant',
  'Hustle',
  'Cute Charm',
  'Plus',
  'Minus',
  'Forecast',
  'Sticky Hold',
  'Shed Skin',
  'Guts',
  'Marvel Scale',
  'Liquid Ooze',
  'Overgrow',
  'Blaze',
  'Torrent',
  'Swarm',
  'Rock Head',
  'Drought',
  'Arena Trap',
  'Vital Spirit',
  'White Smoke',
  'Pure Power',
  'Shell Armor',
  'Air Lock',
  'Tangled Feet',
  'Motor Drive',
  'Rivalry',
  'Steadfast',
  'Snow Cloak',
  'Gluttony',
  'Anger Point',
  'Unburden',
  'Heatproof',
  'Simple',
  'Dry Skin',
  'Download',
  'Iron Fist',
  'Poison Heal',
  'Adaptability',
  'Skill Link',
  'Hydration',
  'Solar Power',
  'Quick Feet',
  'Normalize',
  'Sniper',
  'Magic Guard',
  'No Guard',
  'Stall',
  'Technician',
  'Leaf Guard',
  'Klutz',
  'Mold Breaker',
  'Super Luck',
  'Aftermath',
  'Anticipation',
  'Forewarn',
  'Unaware',
  'Tinted Lens',
  'Filter',
  'Slow Start',
  'Scrappy',
  'Storm Drain',
  'Ice Body',
  'Solid Rock',
  'Snow Warning',
  'Honey Gather',
  'Frisk',
  'Reckless',
  'Multitype',
  'Flower Gift',
  'Bad Dreams',
  'Pickpocket',
  'Sheer Force',
  'Contrary',
  'Unnerve',
  'Defiant',
  'Defeatist',
  'Cursed Body',
  'Healer',
  'Friend Guard',
  'Weak Armor',
  'Heavy Metal',
  'Light Metal',
  'Multiscale',
  'Toxic Boost',
  'Flare Boost',
  'Harvest',
  'Telepathy',
  'Moody',
  'Overcoat',
  'Poison Touch',
  'Regenerator',
  'Big Pecks',
  'Sand Rush',
  'Wonder Skin',
  'Analytic',
  'Illusion',
  'Imposter',
  'Infiltrator',
  'Mummy',
  'Moxie',
  'Justified',
  'Rattled',
  'Magic Bounce',
  'Sap Sipper',
  'Prankster',
  'Sand Force',
  'Iron Barbs',
  'Zen Mode',
  'Victory Star',
  'Turboblaze',
  'Teravolt',
  'Aroma Veil',
  'Flower Veil',
  'Cheek Pouch',
  'Protean',
  'Fur Coat',
  'Magician',
  'Bulletproof',
  'Competitive',
  'Strong Jaw',
  'Refrigerate',
  'Sweet Veil',
  'Stance Change',
  'Gale Wings',
  'Mega Launcher',
  'Grass Pelt',
  'Symbiosis',
  'Tough Claws',
  'Pixilate',
  'Gooey',
  'Aerilate',
  'Parental Bond',
  'Dark Aura',
  'Fairy Aura',
  'Aura Break',
  'Primordial Sea',
  'Desolate Land',
  'Delta Stream',
  'Stamina',
  'Wimp Out',
  'Emergency Exit',
  'Water Compaction',
  'Merciless',
  'Shields Down',
  'Stakeout',
  'Water Bubble',
  'Steelworker',
  'Berserk',
  'Slush Rush',
  'Long Reach',
  'Liquid Voice',
  'Triage',
  'Galvanize',
  'Surge Surfer',
  'Schooling',
  'Disguise',
  'Battle Bond',
  'Power Construct',
  'Corrosion',
  'Comatose',
  'Queenly Majesty',
  'Innards Out',
  'Dancer',
  'Battery',
  'Fluffy',
  'Dazzling',
  'Soul-Heart',
  'Tangling Hair',
  'Receiver',
  'Power of Alchemy',
  'Beast Boost',
  'RKS System',
  'Electric Surge',
  'Psychic Surge',
  'Misty Surge',
  'Grassy Surge',
  'Full Metal Body',
  'Shadow Shield',
  'Prism Armor',
  'Neuroforce',
  '???',
  'Cotton Down',
  'Ball Fetch',
  'Steam Engine',
  'Ripen',
  'Sand Spit',
  'Gulp Missile',
  'Punk Rock',
  'Wandering Spirit',
  'Power Spot',
  'Ice Face',
  'Hunger Switch',
  'Intrepid Sword',
  'Dauntless Shield',
  'Gorilla Tactics',
  'Mimicry',
  'Screen Cleaner',
  'Pastel Veil',
  'Neutralizing Gas',
  'Libero',
  'Mirror Armor',
  'Propeller Tail',
  'Steely Spirit',
  'Perish Body',
  'Ice Scales',
  'Stalwart',
  'Unseen Fist',
  'Quick Draw',
  'Transistor',
  'Dragon\'s Maw',
  'Chilling Neigh',
  'Grim Neigh',
  'Lingering Aroma',
  'Well-Baked Body',
  'Seed Sower',
  'Purifying Salt',
  'Electromorphosis',
  'Wind Power',
  'Wind Rider',
  'Mycelium Might',
  'Anger Shell',
  'Opportunist',
  'Zero to Hero',
  'Earth Eater',
  'Toxic Debris',
  'Commander',
  'Cud Chew',
  'Protosynthesis',
  'Quark Drive',
  'Thermal Exchange',
  'Good as Gold',
  'Tablets of Ruin',
  'Sword of Ruin',
  'Vessel of Ruin',
  'Beads of Ruin',
  'Orichalcum Pulse',
  'Hadron Engine',
  'Supersweet Syrup',
  'Hospitality',
  'Toxic Chain',
  'Tera Shift',
  'Poison Puppeteer',
  'As One',
  'Mind\'s Eye',
  'Embody Aspect',
  'Tera Shell',
  'Teraform Zero',
  'Curious Medicine',
  'Guard Dog',
  'Sharpness',
  'Silk Trap',
  'Rocky Payload',
  'Costar',
  'Supreme Overlord',
  'Armor Tail'
]
